import { VCardAttributes } from '@/lib/types/VCardT'
import { cn } from '@/lib/utils'
import LcIcon from '@/components/livecontact/icons'
import { CHIP_CLASS, CHIP_REMOVE_CLASS } from '@/components/livecontact/fieldStyles'
import { VCardAvatar } from '@/components/VCardSelectField/DropdownItem'

/** Selected-card chip: 18px avatar, name, remove. */
const VCardTag = ({
  vCard,
  onRemove,
}: {
  vCard: Pick<
    VCardAttributes,
    'id' | 'representativeName' | 'avatar' | 'isAvatarGenerated' | 'mainColor'
  >
  onRemove: (id: number) => void
}) => {
  const name = vCard.representativeName || 'Unknown'

  return (
    <span className={cn(CHIP_CLASS, 'pl-1 animate-lc-pop')}>
      <VCardAvatar vCard={vCard} size={18} />
      <span className="max-w-[160px] truncate">{name}</span>
      <button
        type="button"
        onClick={() => onRemove(vCard.id)}
        aria-label={`Remove ${name}`}
        className={CHIP_REMOVE_CLASS}
      >
        <LcIcon name="close" size={12} />
      </button>
    </span>
  )
}

export default VCardTag
